import axiosInstance from "../axiosInstance";

export const getOrderData = async (data) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const paymentHistoryToken = localStorage.getItem("paymentHistoryToken");
    const userData = userDataString ? JSON.parse(userDataString) : null;

    const params = {
      ...data,
      ...(paymentHistoryToken ? { historyToken: paymentHistoryToken } : {}),
    };

    const response = await axiosInstance.get("/get_checkout_data", {
      params,
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error getting order data", error);
    throw error;
  }
};

export const setOrderFormData = async (data) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const response = await axiosInstance.post("/checkout", data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending order form data", error);
    throw error;
  }
};

export const setFeedback = async (data) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const response = await axiosInstance.post("/add_comments", data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending order form data", error);
    throw error;
  }
};

export const setFeedbackForPartner = async (data) => {
  try {
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const response = await axiosInstance.post(
      "/add_comments_for_service",
      data,
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error sending order form data", error);
    throw error;
  }
};
